import moment from 'moment';

export function getLengthInWeeks(startDate, endDate) {
  const length = getLengthInWeeksValue(startDate, endDate);
  return pluralizeWeeksValue(length);
}

export function getLengthInWeeksValue(startDate, endDate) {
  return Math.ceil(moment.duration(endDate.diff(startDate)).asWeeks());
}

export function getLengthInWeeksInclusiveValue(startDate, endDate) {
  const dayBeforeStartDate = startDate.clone().subtract(1, 'day');
  return Math.ceil(moment.duration(endDate.diff(dayBeforeStartDate)).asWeeks());
}

export function pluralizeWeeksValue(length) {
  return `${length} week${length > 1 ? 's' : ''}`;
}
